@if (datePickerForm) {
<form [formGroup]="datePickerForm" class="form-container">
  <aw-form-field>
    <aw-form-field-label [required]="required()">
      {{ title() }}
    </aw-form-field-label>
    <aw-form-message type="info">
      {{ subtitle() }}
    </aw-form-message>
    <aw-date-picker
      #dateCalendar
      formControlName="date"
      [placeholder]="placeholder()"
      [multiDatePicker]="multiDatePicker()"
    >
    </aw-date-picker>

    <button
      ariaLabel="calendar"
      type="button"
      AwButtonIconOnly
      [buttonType]="'primary'"
      (click)="dateCalendar.openCalendar()"
    >
      <mat-icon [svgIcon]="'today'"> </mat-icon>
    </button>

    @if ( required() && datePickerForm.controls['date'].errors &&
    datePickerForm.controls['date'].touched ) {
    <aw-form-message type="error">
      Use the calendar icon to select dates
    </aw-form-message>
    }
  </aw-form-field>
</form>
}
